import { useState } from 'react';

const footerNav = [
  { label: '今日速报', href: '#feed' },
  { label: '黑料档案', href: '#archive' },
  { label: '黑料名单', href: '#list' },
  { label: '正在热议', href: '#discussion' },
  { label: '吃瓜时间线', href: '#timeline' },
];

const footerTopics = [
  { label: '直播翻车合集', href: '#collections' },
  { label: '带货争议专题', href: '#collections' },
  { label: '考古现场合集', href: '#collections' },
  { label: '响应与声明汇总', href: '#collections' },
  { label: '应援账目核对', href: '#collections' },
];

export default function SiteFooter() {
  const [note, setNote] = useState('');

  const demo = (label: string) => {
    setNote(`演示站点：${label}功能未接入，本页仅作展示`);
  };

  return (
    <footer className="bg-secondary-900 text-background-50">
      <div className="mx-auto max-w-[1240px] px-4 md:px-8 py-8 md:py-12">
        <div className="rounded-lg bg-secondary-800 p-5 md:p-7">
          <div className="flex flex-col lg:flex-row lg:items-center lg:justify-between gap-5">
            <div className="max-w-xl">
              <h2 className="font-heading text-xl md:text-2xl font-black">
                想第一时间看到新档案？
              </h2>
              <p className="mt-2 text-sm text-secondary-100 leading-relaxed">
                把本站收进收藏夹，或留意每日速报的时间线节点，新整理的档案会按状态标注更新。
              </p>
            </div>
            <div className="flex flex-wrap gap-3">
              <button
                type="button"
                onClick={() => demo('收藏')}
                className="inline-flex items-center gap-2 h-10 px-5 rounded-md bg-primary-500 text-background-50 text-sm font-medium whitespace-nowrap cursor-pointer hover:bg-primary-600 transition-colors"
              >
                <i className="ri-bookmark-line" />
                收藏本站
              </button>
              <button
                type="button"
                onClick={() => demo('分享')}
                className="inline-flex items-center gap-2 h-10 px-5 rounded-md border border-secondary-600 text-secondary-50 text-sm whitespace-nowrap cursor-pointer hover:bg-secondary-700 transition-colors"
              >
                <i className="ri-share-forward-line" />
                分享给同好
              </button>
            </div>
          </div>
          {note ? (
            <p className="mt-4 text-xs text-accent-300">{note}</p>
          ) : null}
        </div>

        <div className="mt-8 md:mt-10 grid grid-cols-1 md:grid-cols-12 gap-8">
          <div className="md:col-span-5">
            <div className="flex items-center gap-2">
              <span className="w-9 h-9 rounded-md bg-primary-500 text-background-50 flex items-center justify-center">
                <i className="ri-fire-fill text-lg" />
              </span>
              <span className="font-heading text-xl font-black">网红黑料</span>
            </div>
            <p className="mt-3 text-sm text-secondary-100 leading-relaxed">
              收录近期热门网红的黑料档案，从<span className="text-background-50">网红黑料汇总</span>到网红黑料名单与合集专题，按目录查、按状态看，省去自己翻找的时间。
            </p>
            <div className="mt-4 flex items-center gap-2 text-xs text-secondary-200">
              <i className="ri-information-line" />
              内容为网友整理与演示数据，仅供吃瓜参考，请理性看待。
            </div>
          </div>

          <div className="md:col-span-3">
            <h3 className="text-sm font-bold text-background-50">站内目录</h3>
            <ul className="mt-4 space-y-2.5">
              {footerNav.map((item) => (
                <li key={item.href}>
                  <a href={item.href} className="text-sm text-secondary-100 hover:text-background-50 transition-colors">
                    {item.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div className="md:col-span-4">
            <h3 className="text-sm font-bold text-background-50">专题合集</h3>
            <ul className="mt-4 space-y-2.5">
              {footerTopics.map((item) => (
                <li key={item.label}>
                  <a href={item.href} className="text-sm text-secondary-100 hover:text-background-50 transition-colors">
                    {item.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="mt-8 md:mt-10 pt-6 border-t border-secondary-700 flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3 text-xs text-secondary-200">
          <p>© 2026 网红黑料 · 单页站演示</p>
          <div className="flex flex-wrap items-center gap-4">
            <a href="#top" className="hover:text-background-50 transition-colors">免责声明</a>
            <a href="#top" className="hover:text-background-50 transition-colors">内容规范</a>
            <a href="#top" className="hover:text-background-50 transition-colors">返回顶部</a>
          </div>
        </div>
      </div>
    </footer>
  );
}